<div
  class="flex flex-col gap-3"
  [ngClass]="{ 'bg-white rounded-lg': !modelConfiguration }"
>
  <div class="flex w-full justify-between">
    <h2 class="font-semibold text-lg text-sigecom-dark-gray">
      Configuração das Chaves
    </h2>
    <p class="text-[#787878]">
      {{
        modelConfiguration
          ? (modelKeyForms?.length ?? 0) + ' chaves configuradas'
          : amountOfKeysGenerated + ' chaves encontradas'
      }}
    </p>
  </div>

  <ng-container *ngIf="modelConfiguration; else competitionKeyGeneration">
    <p
      *ngIf="!modelKeyForms?.length"
      class="text-center text-sigecom-gray py-6"
    >
      Informe a quantidade de chaves no passo 1 para configurá-las.
    </p>

    <div
      *ngIf="modelKeyForms?.length"
      class="grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-2 flex-wrap w-full"
    >
      <div
        *ngFor="let key of modelKeyForms?.controls ?? []; let i = index"
        [formGroup]="key"
        class="h-fit px-4 py-4 flex gap-2 col-span-1 flex-col bg-[#E5E7EB] rounded-lg"
      >
        <div class="flex gap-2 justify-center items-center min-h-[32px]">
          <ng-container
            *ngIf="!modelKeysBeingEdited.has(i); else editingModelKeyName"
          >
            <h3 class="text-center text-lg font-bold text-sigecom-dark-gray">
              {{ key.controls.chvTxNome.value }}
            </h3>
            <sigecom-menu-bar-item
              (clickAction)="editModelKeyName(i)"
              icon="pen"
              color="sigecom-info"
              title="Editar chave"
            />
          </ng-container>
          <ng-template #editingModelKeyName>
            <input
              sigecom-input
              type="text"
              class="w-full text-center"
              formControlName="chvTxNome"
              (blur)="finishEditingModelKeyName(i)"
              (keydown.enter)="finishEditingModelKeyName(i)"
            />
          </ng-template>
        </div>

        <sigecom-input-container
          label="Quantidade de Inscrições"
          [isRequired]="true"
          class="bg-white rounded-md"
          [errorMessage]="showError?.('chaveForms.' + i + '.chvNrInscritos')"
        >
          <input
            sigecom-input
            type="number"
            name="chvNrInscritos"
            formControlName="chvNrInscritos"
            placeholder="Ex: 28"
          />
        </sigecom-input-container>

        <sigecom-input-container
          label="Quantidade de Classificações"
          [isRequired]="true"
          class="bg-white rounded-md"
          [errorMessage]="
            key.hasError('classificadosMaiorQueInscritos')
              ? 'Não pode exceder as inscrições'
              : showError?.('chaveForms.' + i + '.chvNrClassificados')
          "
        >
          <input
            sigecom-input
            type="number"
            name="chvNrClassificados"
            formControlName="chvNrClassificados"
            placeholder="Ex: 28"
          />
        </sigecom-input-container>
      </div>
    </div>
  </ng-container>

  <ng-template #competitionKeyGeneration>
    <form [formGroup]="keyFormGroup" class="flex flex-col gap-3">
      <div
        formArrayName="keyList"
        class="grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-2 flex-wrap w-full"
      >
        <div
          *ngFor="
            let item of keyForm.controls;
            let i = index;
            trackBy: trackByCheNrId
          "
          [formGroupName]="i"
          class="h-fit px-4 py-4 flex gap-2 col-span-1 flex-col bg-[#E5E7EB] rounded-lg"
        >
          <div class="flex gap-2 justify-center">
            <h1 class="text-center">{{ item.controls.cheTxNome.value }}</h1>
            <sigecom-menu-bar-item
              (clickAction)="
                openModalEditKeyName(
                  item.controls.cheNrId.value!,
                  item.controls.cheTxNome.value || 'Chave/Grupo'
                )
              "
              icon="pen"
              color="sigecom-info"
              title="Editar chave"
            />
          </div>
          <sigecom-input-container
            label="Quantidade de Inscrições"
            class="bg-white rounded-md"
          >
            <input
              sigecom-input
              type="number"
              name="cheNrQtdInc"
              formControlName="cheNrQtdInc"
              placeholder="Ex: 28"
              (debouncedInput)="emitKey()"
            />
          </sigecom-input-container>
          <sigecom-input-container
            label="Quantidade de Classificações"
            class="bg-white rounded-md"
          >
            <input
              sigecom-input
              type="number"
              name="cheNrQtdInc"
              formControlName="cheNrQtdVencedor"
              placeholder="Ex: 28"
              (debouncedInput)="emitKey()"
            />
          </sigecom-input-container>
        </div>
      </div>
      <sigecom-pagination-list
        *ngIf="keysDto?.content?.length"
        class="mt-7"
        [totalPages]="keysDto?.totalPages!"
        [maxDisplayedPages]="10"
        (pageChange)="onPageChange($event)"
      />
    </form>

    <div class="flex justify-center" *ngIf="keysDto?.empty">
      Nenhuma chave ou grupo foi gerado. Clique no botão 'Gerar Chaves' para
      criar as chaves desta etapa.
    </div>

    <sigecom-modal
      [open]="modalEditKeyName"
      [showCloseButton]="true"
      [closeButtonClass]="'text-gray-500'"
      (modalStateChange)="closeModalEditKeyName()"
      class="w-full max-w-5xl"
    >
      <div class="w-full">
        <p class="text-lg font-medium text-sigecom-dark-gray">
          Editar nome da chave/grupo
        </p>
        <form [formGroup]="keyNameForm" class="pt-4">
          <sigecom-input-container
            label="Nome da chave"
            [errorMessage]="validStringSize(4)"
          >
            <input
              type="text"
              name="cheTxNome"
              formControlName="cheTxNome"
              sigecom-input
            />
          </sigecom-input-container>
        </form>
        <div class="pt-4 w-[702px]">
          <sigecom-button
            class="w-full h-10"
            title="Salvar"
            type="info"
            [disabled]="
              petBlockEdit! || keyNameForm.controls['cheTxNome'].invalid
            "
            (buttonClicked)="editKeyName()"
            icon="save"
            [enableLoading]="saveNameLoading"
          >
          </sigecom-button>
        </div>
      </div>
    </sigecom-modal>
  </ng-template>
</div>
